import ContractDistributionsService from "@/api/services/contractDistributions";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    // Estaly Protect offers, where the device is identified by its IMEI / serial number
    isEstalyProtect: () => (category) =>
      ["multimedia_v2", "integral_v2", "multimedia_v3", "integral_v3"].includes(category),
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.contractDistributions;
      state.currentPage = data.page.currentPage || 1;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex({ commit }, { storeId, page, perPage } = {}) {
      const response = await ContractDistributionsService.fetchIndex({ storeId, page, perPage });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },
    async fetch(_, { id, includes = [] } = {}) {
      const response = await ContractDistributionsService.fetch(id, includes);
      if (!response?.success) return response;

      return toCamelCase(response.data);
    },
    async orderKit(_, { id, storeId }) {
      const response = await ContractDistributionsService.orderKit(id, storeId);
      if (!response?.success) return response;

      return response;
    },
  },
};
